<app-form-field [label]="label()"
                class="operational-status"
                [renderOptional]="false"
                [includeMargin]="false">
  <app-select class="mb-0"
              [formControl]="$any(statusControl)"
              [options]="statusOptions()"
              [formatterTemplate]="formatterTemplate()"
              [required]="true">
    <div class="invalid-feedback">{{ errorLabel() }} clearance status is required</div>
  </app-select>
  @if (showRemarks()) {
    <textarea class="form-control mt-3 mb-0"
              placeholder="Add a remark"
              [formControl]="$any(remarksControl)"
    ></textarea>
    @for (row of attentionPointsArray.controls; track $index) {
      <div class="d-flex flex-row align-items-start gap-2 mt-4">
        <div class="flex-grow-1">
          <app-select placeholder="Select an attention point"
                      [ngModel]="selectedOptionForRow($index)"
                      (ngModelChange)="attentionPointSelectedForRow($index, $event)"
                      [ngModelOptions]="{standalone: true}"
                      [options]="availableOptionsForRow($index)"
                      optionLabel="description"
                      dataKey="type">
          </app-select>
          @if ($any(row).get('type').value) {
            <input class="form-control mt-2"
                   placeholder="Attention point remark"
                   [formControl]="$any(row).get('remarks')"
                   [required]="true">
            <div class="invalid-feedback">A remark is required for the selected attention point</div>
          }
        </div>
        <a (click)="removeAttentionPoint($index)" class="text-danger cursor-pointer mt-2" title="Remove attention point">
          <i class="fa fa-light fa-trash"></i>
        </a>
      </div>
    }
    @if (canAddAttentionPoint) {
      <p class="mb-0 mt-4">
        <a (click)="addAttentionPoint()" class="text-primary cursor-pointer">
          <i class="fa fa-light fa-plus"></i>
          Add attention point
        </a>
      </p>
    }
  }
</app-form-field>
